module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/214.b435cd2f.png";